import React from 'react';

import TextFieldBase from 'components/mui/Form/TextField/TextFieldBase';

const TextFieldTrim = ({ onChange, ...rest }) => {
  const handleChange = (e) => {
    onChange?.(e.target.value.trimStart());
  };
  return <TextFieldBase onChange={handleChange} {...rest} />;
};

export default TextFieldTrim;
